import axios from "axios";
import { services } from "configs/api";
import { toSnakeCaseKeys } from "common/helpers/utils";
import { dataTransferServiceFor } from "configs/products";

// StartDataTransfer / related pages are enroll-only today.
const DEFAULT_PRODUCT = "enroll";

const DataTransfers = {
  get(id, product = DEFAULT_PRODUCT) {
    return axios.get(
      services.productService(product, "data-transfer-internal", id)
    );
  },
  start(payload) {
    const product = payload.product || DEFAULT_PRODUCT;
    const service = dataTransferServiceFor(payload.fromEnvironment);
    return axios.post(
      services.productService(product, service, "initiate"),
      toSnakeCaseKeys(payload)
    );
  },
  getDatabases(environment, product = DEFAULT_PRODUCT) {
    const service = dataTransferServiceFor(environment);
    return axios.get(
      services.productService(
        product,
        service,
        `list-databases/${environment}`
      )
    );
  },
};

export default DataTransfers;
